var map = {
	"./AssignedWidget.vue": "8307",
	"./AssigneeCodingTimeWidget.vue": "1bd3",
	"./BugWidget.vue": "2cdf",
	"./BurndownWidget.vue": "b203",
	"./BurnupWidget.vue": "1f79e",
	"./ChartWidget.vue": "20ed",
	"./CommentWidget.vue": "6082",
	"./CumulativeFlowDiagram.vue": "2d65",
	"./DateDynamicSelectFilter.vue": "0c5f",
	"./KanBanWidget.vue": "8f78",
	"./MergeRequestStatistics.vue": "8148",
	"./MergeTimeDistribution.vue": "96da3",
	"./ProjectSummaryWidget.vue": "64cb",
	"./StatisticsWidget.vue": "e102",
	"./SubmissionEfficiency.vue": "d341",
	"./TeamCodingTimeWidget.vue": "6af1",
	"./TodoListWidget.vue": "b95c",
	"./WorkingHoursStatistics.vue": "e1a4"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return Promise.all(/* lazy-once context */[__webpack_require__.e("chunk-2d0af7de"), __webpack_require__.e("chunk-0794098f"), __webpack_require__.e("chunk-55ece9bc")]).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "a079";
module.exports = webpackAsyncContext;